// sekcie_v1 (20. 10. 2026, 0.J): DetailRow je jeden, v components/Ui.jsx
// vzhlad_predajne_v2 (20. 10. 2026, ústava 61.10): starý oranžový panel/akcent nahradený hodnotami témy — 1 miest
// ╔══════════════════════════════════════════════════════════════════╗
// ║  _ModuleTemplate.jsx — REFERENČNÁ ŠABLÓNA MODULU MATRIX v2        ║
// ║  Ústava 9.D.1 bod 2 — anti-chyba systém.                          ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  NOVÝ MODUL VZNIKÁ KÓPIOU TOHTO SÚBORU — NIKDY NIE OD NULY.       ║
// ║  Tým sa ústavné systémové veci NEDAJÚ vynechať.                   ║
// ║                                                                  ║
// ║  POSTUP (ústava 9.D.1):                                          ║
// ║   1. PRE-FLIGHT dokument — schváli Mirko PRED prvým riadkom.      ║
// ║   2. cp _ModuleTemplate.jsx → views/MojModul.jsx                 ║
// ║   3. Vyplň CFG · EDIT_FIELDS · STATUS_FILTERS · polia formulára.  ║
// ║   4. Nahraď TODO značky. Skontroluj DoD checklist (dole).         ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  ČO JE V ŠABLÓNE ZABUDOVANÉ (ústavné systémové veci):            ║
// ║   • master-detail layout ......................... sek. 56       ║
// ║   • LOCK multi-user (cez useRecordEditor) ........ sek. 53.7      ║
// ║   • DIRTY dialóg pri odchode ..................... sek. 53.1      ║
// ║   • Form → Confirm + DIFF pred uložením .......... 12.0/3 · 53.8  ║
// ║   • audit kto/čo/kedy (HistoryPanel + auto-log) .. 12.0/1         ║
// ║   • fulltext hľadanie v zozname .................. sek. 56        ║
// ║   • SearchableSelect (žiadny plain <select>) ..... sek. 56.11     ║
// ║   • TINT pozadia (žiadne inline farby) ........... sek. 21.15     ║
// ║   • dedup kontrola (409 z backendu) .............. sek. 13        ║
// ║   • klávesnica (mod+N, /) + cheatsheet ........... sek. 54        ║
// ║   • breadcrumb — rieši Layout .................... sek. 53.2      ║
// ╚══════════════════════════════════════════════════════════════════╝

import React, { useState, useMemo, useEffect, useCallback, useRef } from 'react'
import useLiveRefresh from '../hooks/useLiveRefresh.js'
import { COLORS, TYPO, SPACE, RADIUS, TINT, SK, todayLocal, hladaj } from '../theme.js'
import {
  PageHeader, MasterDetail, SearchInput, ListRow, ListStatusBar,
  FilterChips, KpiRow, KpiCard, Tabs, EmptyPane, SearchableSelect, DetailRow } from '../components/Ui.jsx'
import { Modal } from '../components/Modal.jsx'
import { Btn, BtnAdd, BtnGhost } from '../components/Btn.jsx'
import { HistoryPanel } from '../components/HistoryPanel.jsx'
import { useToast } from '../components/Toast.jsx'
import { useShortcuts } from '../hooks/useShortcuts.js'
import { useRecordEditor } from '../hooks/useRecordEditor.js'
import { useListKeyboard } from '../hooks/useListKeyboard.js'
import { usePositionMemory } from '../hooks/usePositionMemory.js'
import { useAuth } from '../auth/AuthContext.jsx'
import { fetchAuth } from '../auth/fetchAuth.js'
import { usePersony } from '../lib/persony.js'
import AttachmentsPanel from '../components/AttachmentsPanel.jsx'
import HelpHint from '../components/HelpHint.jsx'
import RowMenu from '../components/RowMenu.jsx'
import ExportMenu from '../components/ExportMenu.jsx'
import { useNavigate } from 'react-router-dom'
import { useConfirm } from '../components/ConfirmDialog.jsx'

// ╔═══ KONFIGURÁCIA MODULU — VYPLŇ PRI KOPÍROVANÍ ═══════════════════╗
// DÔLEŽITÉ: resource MUSÍ byť presne cesta API segmentu (napr. 'work-schedule'
// pre /api/work-schedule). Server zapisuje audit pod týmto názvom — ak sa
// nezhoduje, HistoryPanel nenájde históriu (ústava-review 9.D.3).
const CFG = {
  resource:    'vehicles',
  apiBase:     '/api/vehicles',
  titlePlural: 'Vozový park',
  newLabel:    'Nové vozidlo',
}

// Polia pre DIFF (ústava 53.8) — useRecordEditor ich porovná initial vs. zmenené.
// label = ako sa pole volá v Confirm prehľade. format = voliteľné zobrazenie.
const EDIT_FIELDS = [
  { name: 'name',        label: 'Názov' },
  { name: 'plate',       label: 'ŠPZ' },
  { name: 'vin',         label: 'VIN' },
  { name: 'year',        label: 'Rok' },
  { name: 'color',       label: 'Farba' },
  { name: 'fuel',        label: 'Palivo' },
  { name: 'km',          label: 'Stav km' },
  { name: 'stk',         label: 'STK do' },
  { name: 'insurance',   label: 'Poistka do' },
  { name: 'vignette',    label: 'Diaľničná do' },
  { name: 'green_card',  label: 'Zelená karta do' },
  { name: 'leasing',     label: 'Leasing' },
  { name: 'leasing_end', label: 'Leasing do' },
  { name: 'assigned_to_employee_id', label: 'Pridelené zamestnancovi' },
  { name: 'brand',       label: 'Značka' },
  { name: 'model',       label: 'Model' },
  { name: 'vehicle_type', label: 'Typ vozidla' },
  { name: 'first_registration', label: '1. evidencia' },
  { name: 'power_kw',    label: 'Výkon (kW)' },
  { name: 'engine_cc',   label: 'Objem (cm³)' },
  { name: 'transmission', label: 'Prevodovka' },
  { name: 'seats',       label: 'Počet miest' },
  { name: 'max_weight',  label: 'Najv. hmotnosť' },
  { name: 'ek',          label: 'EK do' },
  { name: 'pzp_insurer', label: 'PZP poisťovňa' },
  { name: 'pzp_policy',  label: 'PZP číslo zmluvy' },
  { name: 'pzp_premium', label: 'PZP poistné' },
  { name: 'havarijna_insurer', label: 'Havarijná poisťovňa' },
  { name: 'havarijna_do', label: 'Havarijná do' },
  { name: 'havarijna_premium', label: 'Havarijná poistné' },
  { name: 'keys_count',  label: 'Počet kľúčov' },
  { name: 'keys_location', label: 'Kde sú kľúče' },
  { name: 'tyre_spec',   label: 'Pneumatiky (z TP)' },
  { name: 'owner',       label: 'Majiteľ (vlastník)' },
  { name: 'holder',      label: 'Držiteľ' },
  { name: 'notes',       label: 'Poznámka' },
]

// Filter chips (ústava 21.15 — farby gest). key 'all' = bez filtra.
const STATUS_FILTERS = [
  { key: 'all',    label: 'Všetky',   color: COLORS.muted },
  { key: 'active', label: 'V prevádzke', color: COLORS.add },
  { key: 'off',    label: 'Vyradené', color: COLORS.muted },
]
const STATUS_LABEL = { active: 'Aktívny', inactive: 'Neaktívny' }

// ══════════════════════════════════════════════════════════════════
// HLAVNÝ KOMPONENT — master-detail stránka (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
export default function VozidlaView() {
  const { user } = useAuth()                 // user pre LOCK (53.7)
  const toast = useToast()
  const confirm = useConfirm()

  // ── pamäť pozície (ústava 53.3) — obnoví výber / filter / hľadanie / scroll ──
  const pos = usePositionMemory(CFG.resource)
  const listRef = useRef(null)

  const [rows, setRows]       = useState([])
  const [loading, setLoading] = useState(true)
  const [showComplete, setShowComplete] = useState(false)
  const [showExpiry, setShowExpiry] = useState(false)
  const [emps, setEmps]       = useState([])
  useEffect(() => { fetchAuth('/api/employees').then(r => r.ok ? r.json() : []).then(d => setEmps(Array.isArray(d) ? d : (d.rows || []))).catch(() => {}) }, [])
  const [search, setSearch]   = useState(pos.filter?.search || '')
  const [filter, setFilter]   = useState(pos.filter?.status || 'all')
  const [typeFilter, setTypeFilter] = useState('all')
  const [viewMode, setViewMode] = useState('all')  // 'all' | 'employee' (zoskupenie podľa prideleného)
  const [selectedId, setSelectedId] = useState(pos.selectedRow || null)
  const [initialTab, setInitialTab] = useState(null)  // tri bodky → rovno na tab (napr. Prevzatie/Odovzdanie)
  const [modal, setModal]     = useState(null)  // null | {record} | {record:null}

  // ── načítanie dát ────────────────────────────────────────────────
  const load = useCallback(async () => {
    setLoading(true)
    try {
      const r = await fetchAuth(CFG.apiBase)
      const d = await r.json()
      setRows(Array.isArray(d) ? d : (d.rows || []))
    } catch (_) {
      toast.error('Dáta sa nenačítali.')
    } finally {
      setLoading(false)
    }
  }, [toast])

  useEffect(() => { load() }, [load])
  useLiveRefresh(load)  // živé obnovenie (SSE, ústava 97)

  // ── filter + fulltext hľadanie (ústava sek. 56) ──────────────────
  const filtered = useMemo(() => {
    const q = search.trim().toLowerCase()
    return rows.filter(row => {
      if (typeFilter !== 'all' && (row.vehicle_type || '').toLowerCase() !== typeFilter.toLowerCase()) return false
      if (!q) return true
      // hľadá vo všetkých textových poliach záznamu
      return Object.values(row).some(v =>
        v != null && hladaj(String(v), q))
    }).sort((a, b) => (a.name || '').localeCompare(b.name || '', 'sk'))
  }, [rows, search, typeFilter])

  // Zoskupenie podľa prideleného zamestnanca (vlákno auto↔zamestnanec)
  const groupedList = useMemo(() => {
    if (viewMode !== 'employee') return [{ key: '_all', header: null, items: filtered }]
    const byEmp = {}
    filtered.forEach(v => {
      const nm = (emps.find(e => e.id === v.assigned_to_employee_id) || {}).name || '— nepridelené —'
      ;(byEmp[nm] = byEmp[nm] || []).push(v)
    })
    return Object.keys(byEmp).sort((a, b) => a.startsWith('—') ? 1 : b.startsWith('—') ? -1 : a.localeCompare(b, 'sk')).map(k => ({ key: k, header: k, items: byEmp[k] }))
  }, [filtered, viewMode, emps])

  const selected = useMemo(
    () => rows.find(r => r.id === selectedId) || null,
    [rows, selectedId])

  // ── pamäť pozície — zápis zmien (ústava 53.3) ────────────────────
  useEffect(() => { pos.selectRow(selectedId) }, [selectedId, pos.selectRow])
  useEffect(() => { pos.setFilter({ status: filter, search }) }, [filter, search, pos.setFilter])
  useEffect(() => {
    if (!loading && listRef.current) pos.restoreScroll(listRef.current)
  }, [loading])  // eslint-disable-line react-hooks/exhaustive-deps

  // ── klávesová navigácia zoznamu (ústava 54.2, 56.5) — zdieľaný hook ──
  const openRecord = useCallback((row) => setModal({ record: row }), [])
  useListKeyboard({
    items: filtered,
    selectedId,
    onSelect: setSelectedId,
    onOpen: openRecord,
    enabled: !modal,
  })

  // ── klávesové skratky (ústava sek. 54) ───────────────────────────
  useShortcuts([
    { keys: 'alt+n', label: CFG.newLabel, scope: CFG.resource,
      handler: () => setModal({ record: null }) },
    { keys: '/', label: 'Hľadať', scope: CFG.resource, handler: () => {
      const el = document.querySelector(`[data-${CFG.resource}-search]`)
      if (el) el.focus()
    } },
  ])

  // ── KPI súhrn (ústava sek. 56.8) ─────────────────────────────────
  const kpi = useMemo(() => ({
    total:  rows.length,
    active: rows.filter(r => r.active).length,
  }), [rows])

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <PageHeader title={CFG.titlePlural} subtitle={`${filtered.length} z ${rows.length}`}>
        <ExportMenu
          data={filtered}
          filename={`vozový-park-${todayLocal()}`}
          title="Vozový park"
          columns={[
            { key: 'id', label: 'ID' },
            { key: 'name', label: 'Názov' },
            { key: 'plate', label: 'ŠPZ' },
            { key: 'vin', label: 'VIN' },
            { key: 'year', label: 'Rok' },
            { key: 'km', label: 'Km' },
            { key: 'stk', label: 'STK do' },
            { key: 'insurance', label: 'Poistka do' },
          ]}
        />
        <Btn variant="ghost" onClick={() => setShowExpiry(true)}>Termíny (expiruje)</Btn>
        <Btn variant="ghost" onClick={() => window.open('/api/vehicles/fleet-export', '_blank')}>Export flotily (poisťovňa)</Btn>
        <Btn variant="ghost" onClick={() => setShowComplete(true)}>Treba dorobiť</Btn>
        <BtnAdd onClick={() => setModal({ record: null })}>+ {CFG.newLabel}</BtnAdd>
      </PageHeader>

      <KpiRow cols={2}>
        <KpiCard title="Spolu" color={COLORS.nav} value={kpi.total} />
        <KpiCard title="Aktívne" color={COLORS.add} value={kpi.active} />
      </KpiRow>

      <div style={{ height: SPACE.md }} />

      <MasterDetail
        leftWidth={320}
        left={
          <>
            <SearchInput value={search} onChange={setSearch}
              dataAttr={`data-${CFG.resource}-search`}
              placeholder="Hľadať (stlač /)…" />
            <div style={{ display: 'flex', gap: 6, alignItems: 'center', padding: '4px 8px 2px' }}>
              {[{ k: 'all', l: 'Všetky' }, { k: 'employee', l: 'Zamestnanec' }].map(v => {
                const on = viewMode === v.k
                return <button key={v.k} onClick={() => setViewMode(v.k)} style={{ flex: 1, padding: '6px 8px', fontSize: TYPO.sizes.xs, fontWeight: 700, borderRadius: RADIUS.md, cursor: 'pointer', fontFamily: 'inherit', color: on ? '#fff' : COLORS.muted, background: on ? COLORS.brand : COLORS.bg, border: `1px solid ${on ? COLORS.brand : COLORS.line}` }}>{v.l}</button>
              })}
              <HelpHint section="70" text="ČO: Všetky = celý vozový park. Zamestnanec = autá zoskupené podľa toho komu sú pridelené (vlákno auto↔zamestnanec). PREČO: hneď vidíš kto má ktoré auto. KAM: pridelenie nastavíš v karte → Upraviť → Pridelené zamestnancovi." />
            </div>
            <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center', padding: '6px 10px', background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, marginBottom: SPACE.sm }}>
              <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, fontWeight: 700 }}>Typ:</span>
              {[{ k: 'all', l: 'Všetko' }, { k: 'osobné', l: 'Osobné' }, { k: 'dodávka', l: 'Dodávka' }, { k: 'nákladné', l: 'Nákladné' }].map(o => {
                const on = typeFilter === o.k
                return <button key={o.k} onClick={() => setTypeFilter(o.k)} style={{ padding: '3px 11px', fontSize: TYPO.sizes.xs, fontWeight: 600, borderRadius: RADIUS.full, cursor: 'pointer', fontFamily: 'inherit', whiteSpace: 'nowrap', color: on ? '#fff' : COLORS.brand, background: on ? COLORS.brand : 'transparent', border: `1px solid ${COLORS.brand}` }}>{o.l}</button>
              })}
            </div>
            <div ref={listRef}
              onScroll={e => pos.saveScroll(e.currentTarget.scrollLeft, e.currentTarget.scrollTop)}
              style={{ flex: 1, overflow: 'auto', padding: 6 }}>
              {loading ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Načítavam…
                </div>
              ) : filtered.length === 0 ? (
                <div style={{ padding: SPACE.lg, color: COLORS.muted, fontSize: TYPO.sizes.sm }}>
                  Žiadne záznamy.
                </div>
              ) : groupedList.map(g => (
                <div key={g.key}>
                  {g.header && <div style={{ position: 'sticky', top: 0, zIndex: 1, background: COLORS.bgSoft, borderBottom: `1px solid ${COLORS.line}`, padding: '5px 8px', fontSize: TYPO.sizes.xs, fontWeight: 800, color: COLORS.nav, textTransform: 'uppercase', letterSpacing: '.03em' }}>{g.header} <span style={{ color: COLORS.muted, fontWeight: 600 }}>({g.items.length})</span></div>}
                  {g.items.map(row => (
                <ListRow key={row.id}
                  dataId={row.id}
                  selected={row.id === selectedId}
                  onClick={() => { setSelectedId(row.id); setInitialTab(null) }}
                  onDoubleClick={() => setModal({ record: row })}
                >
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <div style={{ width: 56, height: 56, flexShrink: 0, borderRadius: RADIUS.sm, background: COLORS.bgSoft, border: `1px solid ${COLORS.line}`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <VehicleIcon type={row.vehicle_type} size={34} />
                    </div>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: TYPO.weights.semibold, color: COLORS.text, whiteSpace: 'normal', wordBreak: 'break-word', lineHeight: 1.25 }}>{row.name || '(bez názvu)'}</div>
                      <div style={{ fontSize: TYPO.sizes.xs, marginTop: 2 }}>
                        {row.plate ? <span style={{ color: COLORS.brand, fontWeight: 800, fontFamily: TYPO.mono }}>{row.plate}</span> : null}
                        <span style={{ color: COLORS.muted, fontFamily: TYPO.mono }}>{row.km ? ' · ' + Number(row.km).toLocaleString('sk-SK') + ' km' : ''}{row.stk ? ' · STK ' + row.stk : ''}</span>
                      </div>
                    </div>
                    <div style={{ flexShrink: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                      <StatusTag status={row.active ? 'V prevádzke' : 'Vyradené'} active={row.active} />
                      <RowMenu actions={[
                        { key: 'edit',  label: 'Upraviť',      onClick: () => setModal({ record: row }) },
                        { key: 'proto', label: 'Prevzatie / Odovzdanie', onClick: () => { setSelectedId(row.id); setInitialTab('protokol') } },
                        { key: 'fuel',  label: 'Tankovanie',   onClick: () => { setSelectedId(row.id); setInitialTab('fuel') } },
                        { key: 'svc',   label: 'Servis',       onClick: () => { setSelectedId(row.id); setInitialTab('service') } },
                        { key: 'print', label: 'Tlačiť kartu', onClick: () => alert('Tlač — pripravujeme') },
                        { key: 'pdf',   label: 'Uložiť ako PDF', onClick: () => alert('PDF — pripravujeme') },
                        { separator: true },
                        { key: 'del',   label: row.active ? 'Vyradiť z prevádzky' : 'Vrátiť do prevádzky',
                          danger: row.active,
                          onClick: async () => {
                            const ok = await confirm({
                              title: row.active ? 'Vyradiť vozidlo z prevádzky?' : 'Vrátiť vozidlo do prevádzky?',
                              message: `${row.name} (${row.plate || row.id})`,
                              danger: row.active, confirmLabel: row.active ? 'Vyradiť' : 'Vrátiť',
                            })
                            if (!ok) return
                            try {
                              const r = await fetchAuth(`/api/vehicles/${row.id}`, {
                                method: 'PUT',
                                headers: { 'Content-Type': 'application/json' },
                                body: JSON.stringify({ ...row, active: row.active ? 0 : 1 }),
                              })
                              if (!r.ok) throw new Error('UPDATE zlyhal')
                              toast.success(row.active ? 'Vyradené' : 'Vrátené do prevádzky')
                              load()
                            } catch (e) { toast.error('Chyba: ' + e.message) }
                          } },
                      ]} />
                    </div>
                  </div>
                </ListRow>
                  ))}
                </div>
              ))}
            </div>
            <ListStatusBar>
              ↑↓ výber · Enter detail · Alt+N nový · / hľadať
            </ListStatusBar>
          </>
        }
        right={
          selected
            ? <DetailPane record={selected} emps={emps} initialTab={initialTab} onEdit={() => setModal({ record: selected })} onAiFill={(patch) => setModal({ record: selected, aiPatch: patch })} onReload={load} />
            : <EmptyPane text="Vyber záznam zo zoznamu vľavo" />
        }
      />

      {modal && (
        <RecordModal
          open
          record={modal.record}
          aiPatch={modal.aiPatch}
          user={user}
          onClose={() => setModal(null)}
          onSaved={() => {
            setModal(null)
            load()
            toast.success('Uložené.')
          }}
        />
      )}
      {showComplete && <CompletenessModal vehicles={rows} onClose={() => setShowComplete(false)} onPick={(v) => { setShowComplete(false); setModal({ record: v }) }} />}
      {showExpiry && <ExpiryModal vehicles={rows} onClose={() => setShowExpiry(false)} onPick={(v) => { setShowExpiry(false); if (v) { setSelectedId(v.id); pos.selectRow && pos.selectRow(v.id) } }} />}
    </div>
  )
}

// ── Expiry dashboard — čo expiruje (STK/EK/PZP/diaľničná/leasing) všetkých áut (návrh #4) ──
function ExpiryModal({ vehicles, onClose, onPick }) {
  const [alerts, setAlerts] = useState(null)
  useEffect(() => { fetchAuth('/api/vehicle-alerts?days=90').then(r => r.ok ? r.json() : []).then(d => setAlerts(Array.isArray(d) ? d : [])).catch(() => setAlerts([])) }, [])
  const col = (a) => a.overdue ? COLORS.remove : a.urgent ? '#b45309' : a.warning ? COLORS.warn : COLORS.nav
  return (
    <Modal open title="Termíny — čo expiruje (90 dní)" onClose={onClose} maxWidth={620}>
      <div style={{ padding: SPACE.sm }}>
        {alerts === null ? <div style={{ color: COLORS.muted }}>Načítavam…</div>
          : alerts.length === 0 ? <div style={{ color: COLORS.add, fontWeight: 700 }}>Žiadne termíny v najbližších 90 dňoch ✓</div>
          : (
            <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
              <thead><tr style={{ borderBottom: `1px solid ${COLORS.line}`, color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase' }}>
                <th style={{ textAlign: 'left', padding: '4px 6px' }}>Vozidlo</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Typ</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Termín</th><th></th>
              </tr></thead>
              <tbody>{alerts.map((a, i) => (
                <tr key={i} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                  <td style={{ padding: '5px 6px', fontWeight: 700 }}>{a.vehicle_name} <span style={{ color: COLORS.brand }}>{a.plate}</span></td>
                  <td style={{ padding: '5px 6px' }}>{a.label}</td>
                  <td style={{ padding: '5px 6px', fontFamily: TYPO.mono, color: col(a), fontWeight: 700 }}>{a.due_date} ({a.overdue ? 'EXPIROVANÉ' : 'za ' + a.days_left + ' dní'})</td>
                  <td style={{ padding: '5px 6px', textAlign: 'right' }}><Btn variant="ghost" onClick={() => onPick(vehicles.find(x => x.id === a.vehicle_id))}>Otvoriť</Btn></td>
                </tr>
              ))}</tbody>
            </table>
          )}
      </div>
    </Modal>
  )
}

// ── Panel „Treba dorobiť" — autá s chýbajúcimi povinnými poľami (návrh #7 + Mirko) ──
function CompletenessModal({ vehicles, onClose, onPick }) {
  const [data, setData] = useState(null)
  useEffect(() => { fetchAuth('/api/vehicles/completeness').then(r => r.ok ? r.json() : []).then(d => setData(Array.isArray(d) ? d : [])).catch(() => setData([])) }, [])
  return (
    <Modal open title="Treba dorobiť — chýbajúce údaje" onClose={onClose} maxWidth={560}>
      <div style={{ padding: SPACE.sm }}>
        {data === null ? <div style={{ color: COLORS.muted }}>Načítavam…</div>
          : data.length === 0 ? <div style={{ color: COLORS.add, fontWeight: 700 }}>Všetky autá majú kompletné povinné údaje ✓</div>
          : (
            <>
              <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: SPACE.sm }}>Predajňa/servis nech doplní. Povinné: ŠPZ · VIN · Značka · Model · Typ · Rok · STK · Palivo.</div>
              {data.map(v => {
                const full = vehicles.find(x => x.id === v.id) || { id: v.id, name: v.name }
                return (
                  <div key={v.id} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <div style={{ fontWeight: 700 }}>{v.name} {v.plate ? <span style={{ color: COLORS.brand }}>{v.plate}</span> : null}</div>
                      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.remove }}>chýba: {v.missing.join(' · ')}</div>
                    </div>
                    <Btn variant="nav" onClick={() => onPick(full)}>Doplniť</Btn>
                  </div>
                )
              })}
            </>
          )}
      </div>
    </Modal>
  )
}

// ══════════════════════════════════════════════════════════════════
// STATUS TAG — farebný štítok stavu (ústava 21.15 — z TINT, nie inline)
// ══════════════════════════════════════════════════════════════════
function StatusTag({ status, active = true }) {
  return (
    <span style={{
      fontSize: TYPO.sizes.xs,
      fontWeight: TYPO.weights.semibold,
      color: active ? COLORS.add : COLORS.muted,
      background: active ? TINT.add : COLORS.lineSoft,
      borderRadius: RADIUS.sm,
      padding: '1px 7px',
    }}>{status || '—'}</span>
  )
}

// ══════════════════════════════════════════════════════════════════
// DETAIL PANE — pravá strana, taby Detail / História (ústava sek. 56)
// ══════════════════════════════════════════════════════════════════
// Typ-ikona vozidla — čiarové SVG (ústava 2724: žiadne emoji)
function VehicleIcon({ type, size = 30 }) {
  const p = { width: size, height: size, viewBox: '0 0 24 24', fill: 'none', stroke: COLORS.brand, strokeWidth: 1.7, strokeLinecap: 'round', strokeLinejoin: 'round', style: { flexShrink: 0 } }
  const t = (type || '').toLowerCase()
  if (/nákl|truck/.test(t)) return <svg {...p}><path d="M2 17V7h11v10M13 10h4l3 3v4h-7" /><circle cx="6.5" cy="17.5" r="1.6" /><circle cx="17.5" cy="17.5" r="1.6" /></svg>
  if (/dodáv|van/.test(t)) return <svg {...p}><path d="M2 16V6h12v10M14 9h3l3 3v4h-6" /><circle cx="6" cy="17" r="1.6" /><circle cx="17" cy="17" r="1.6" /></svg>
  if (/príves/.test(t)) return <svg {...p}><rect x="3" y="8" width="16" height="7" rx="1" /><circle cx="9" cy="17" r="1.6" /><path d="M19 12h2" /></svg>
  if (/stroj/.test(t)) return <svg {...p}><circle cx="12" cy="12" r="8" /><circle cx="12" cy="12" r="3" /><path d="M12 4v2M12 18v2M4 12h2M18 12h2" /></svg>
  return <svg {...p}><path d="M3 13l2-5h14l2 5v4h-2M3 17v-4M3 13h18" /><circle cx="7" cy="17" r="1.6" /><circle cx="17" cy="17" r="1.6" /></svg>
}
function TpAiButton({ record, onAiFill }) {
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  const ref = useRef(null)
  const FIELDS = ['plate', 'vin', 'brand', 'model', 'vehicle_type', 'year', 'first_registration', 'fuel', 'power_kw', 'engine_cc', 'color', 'seats', 'max_weight', 'tyre_spec', 'owner', 'holder']
  const onFile = async (e) => {
    const f = e.target.files && e.target.files[0]; e.target.value = ''
    if (!f) return
    setBusy(true)
    try {
      const fd = new FormData(); fd.append('file', f)
      const r = await fetchAuth('/api/vehicles/tp-extract', { method: 'POST', body: fd })
      const d = await r.json().catch(() => ({}))
      if (d.noKey) { toast.error('AI kľúč nie je nakonfigurovaný (.env)'); setBusy(false); return }
      const ex = d.extracted || {}
      const patch = {}; let filled = 0, read = 0
      FIELDS.forEach(k => { const v = ex[k]; if (v !== null && v !== undefined && v !== '') { read++; if (!String(record[k] || '').trim()) { patch[k] = v; filled++ } } })
      if (!filled) { toast.error(read ? `AI prečítalo ${read} polí, ale sú už vyplnené — over/prepíš ručne` : 'AI z TP neprečítalo nič — skús ostrejšiu fotku alebo druhú stranu TP'); setBusy(false); return }
      toast.success(`AI vyplnilo ${filled} polí — skontroluj a Ulož`); onAiFill(patch)
    } catch (_) { toast.error('AI extrakcia z TP zlyhala') }
    setBusy(false)
  }
  return (
    <>
      <input ref={ref} type="file" accept="image/*,application/pdf" capture="environment" style={{ display: 'none' }} onChange={onFile} />
      <Btn variant="ghost" onClick={() => ref.current && ref.current.click()} disabled={busy}>{busy ? 'AI číta TP…' : 'Načítať z TP (AI)'}</Btn>
    </>
  )
}
// Generická AI extrakcia dokladu (poistka/leasing) → polia vozidla
function DocAiButton({ record, onAiFill, endpoint, label, fields }) {
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  const ref = useRef(null)
  const onFile = async (e) => {
    const f = e.target.files && e.target.files[0]; e.target.value = ''
    if (!f) return
    setBusy(true)
    try {
      const fd = new FormData(); fd.append('file', f)
      const r = await fetchAuth(endpoint, { method: 'POST', body: fd })
      const d = await r.json().catch(() => ({}))
      if (d.noKey) { toast.error('AI kľúč nie je nakonfigurovaný'); setBusy(false); return }
      const ex = d.extracted || {}
      const patch = {}; let filled = 0
      fields.forEach(k => { const v = ex[k]; if (v !== null && v !== undefined && v !== '' && !String(record[k] || '').trim()) { patch[k] = v; filled++ } })
      if (!filled) { toast.error('AI nenašlo nové údaje (alebo sú už vyplnené)'); setBusy(false); return }
      toast.success(`AI vyplnilo ${filled} polí — skontroluj a Ulož`); onAiFill(patch)
    } catch (_) { toast.error('AI extrakcia zlyhala') }
    setBusy(false)
  }
  return (
    <>
      <input ref={ref} type="file" accept="image/*,application/pdf" capture="environment" style={{ display: 'none' }} onChange={onFile} />
      <Btn variant="ghost" onClick={() => ref.current && ref.current.click()} disabled={busy}>{busy ? 'AI číta…' : label}</Btn>
    </>
  )
}
function DetailPane({ record, onEdit, emps = [], onAiFill, onReload, initialTab }) {
  const [tab, setTab] = useState(initialTab || 'detail')
  useEffect(() => { if (initialTab) setTab(initialTab) }, [initialTab, record.id])
  const empName = (emps.find(e => e.id === record.assigned_to_employee_id) || {}).name || ''
  return (
    <div style={{
      background: COLORS.bg,
      border: `1px solid ${COLORS.line}`,
      borderRadius: RADIUS.lg,
      height: '100%',
      display: 'flex', flexDirection: 'column',
      overflow: 'hidden',
    }}>
      {/* HLAVIČKA KARTY — tenký stavový pásik + čierny názov (ústava 61.6) */}
      <div style={{ height: 4, background: COLORS.brand }} />
      <div style={{
        display: 'flex', alignItems: 'center', gap: SPACE.md,
        padding: `${SPACE.md}px ${SPACE.lg}px`,
        borderBottom: `1px solid ${COLORS.line}`,
      }}>
        <VehicleIcon type={record.vehicle_type} />
        <h2 style={{ margin: 0, fontSize: TYPO.sizes.lg, fontWeight: TYPO.weights.extra,
          color: COLORS.text }}>
          {record.name || '(bez názvu)'}{record.plate ? <span style={{ color: COLORS.brand, fontWeight: 900, marginLeft: 8 }}>{record.plate}</span> : null}
        </h2>
        <StatusTag status={record.active ? 'V prevádzke' : 'Vyradené'} active={record.active} />
        <div style={{ flex: 1 }} />
        <HelpHint section="70" text="ČO: karta vozidla — doklady, lehoty, náklady, servis, poškodenia, kontroly. PREČO AI: odfotíš TP/poistku/leasing a AI vyplní polia; v Servis tabe tlačidlo Načítať-AI nájde konkrétnu údržbu pre tento model/VIN. KAM: Doklady = poistka/leasing AI · Servis = AI servisný plán · Kontrola = pred-jazdná DVIR. AI vyplní len prázdne polia, ty potvrdíš." />
        <TpAiButton record={record} onAiFill={onAiFill} />
        <Btn variant="nav" onClick={onEdit}>Upraviť</Btn>
      </div>

      <div style={{ padding: SPACE.md, overflow: 'auto', flex: 1, background: COLORS.bg,
        border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.lg }}>
        <Tabs
          value={tab}
          onChange={setTab}
          tabs={[
            { key: 'detail',  label: 'Detail' },
            { key: 'naklady', label: 'Náklady' },
            { key: 'kontrola', label: 'Kontrola' },
            { key: 'service', label: 'Servis' },
            { key: 'fuel',    label: 'Tankovanie' },
            { key: 'doklady', label: 'Doklady' },
            { key: 'damage',  label: 'Poškodenia' },
            { key: 'protokol', label: 'Prevzatie/Odovzdanie' },
            { key: 'fotky',   label: 'Fotky' },
            { key: 'history', label: 'História' },
          ]}
        />
        {tab === 'detail' ? (
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
            <VSekcia title="Identifikácia" />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="ŠPZ" value={record.plate} mono />
              <KrosF label="VIN" value={record.vin} mono />
              <KrosF label="Typ vozidla" value={record.vehicle_type} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Značka" value={record.brand} />
              <KrosF label="Model" value={record.model} />
              <KrosF label="Rok / 1. evidencia" value={[record.year, record.first_registration].filter(Boolean).join(' · ')} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Palivo" value={record.fuel} />
              <KrosF label="Výkon (kW)" value={record.power_kw} mono />
              <KrosF label="Objem (cm³)" value={record.engine_cc} mono />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Prevodovka" value={record.transmission} />
              <KrosF label="Počet miest" value={record.seats} mono />
              <KrosF label="Najv. hmotnosť (kg)" value={record.max_weight} mono />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: SPACE.sm }}>
              <KrosF label="Farba" value={record.color} />
              <KrosF label="Pneumatiky (z TP)" value={record.tyre_spec} />
            </div>
            <VSekcia title="Doklady a lehoty" />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="STK do" value={record.stk} mono />
              <KrosF label="EK do" value={record.ek} mono />
              <KrosF label="Diaľničná do" value={record.vignette} mono />
              <KrosF label="Zelená karta do" value={record.green_card} mono />
            </div>
            <VSekcia title="Poistenie" />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="PZP poistka do" value={record.insurance} mono />
              <KrosF label="PZP poisťovňa" value={record.pzp_insurer} />
              <KrosF label="PZP č. zmluvy / poistné" value={[record.pzp_policy, record.pzp_premium ? record.pzp_premium + ' €' : ''].filter(Boolean).join(' · ')} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Havarijná do" value={record.havarijna_do} mono />
              <KrosF label="Havarijná poisťovňa" value={record.havarijna_insurer} />
              <KrosF label="Havarijná poistné" value={record.havarijna_premium ? record.havarijna_premium + ' €' : ''} mono />
            </div>
            <VSekcia title="Prevádzka a kľúče" />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Stav km" value={record.km} mono />
              <KrosF label="Pridelené (komu patrí)" value={empName} />
              <KrosF label="Kľúče" value={[record.keys_count ? record.keys_count + ' ks' : '', record.keys_location].filter(Boolean).join(' · ')} />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Majiteľ (vlastník)" value={record.owner} />
              <KrosF label="Držiteľ" value={record.holder} />
            </div>
            <VSekcia title="Leasing" />
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.sm }}>
              <KrosF label="Leasing (spoločnosť)" value={record.leasing} />
              <KrosF label="Leasing do" value={record.leasing_end} mono />
            </div>
            {record.notes ? <KrosF label="Poznámka" value={record.notes} /> : null}
          </div>
        ) : tab === 'naklady' ? (
          <NakladyTabV record={record} />
        ) : tab === 'kontrola' ? (
          <KontrolaTabV vehicleId={record.id} currentKm={record.km} />
        ) : tab === 'service' ? (
          <ServiceTabV record={record} onReload={onReload} />
        ) : tab === 'fuel' ? (
          <FuelTabV vehicleId={record.id} />
        ) : tab === 'doklady' ? (
          <div style={{ paddingTop: SPACE.md }}>
            <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: SPACE.sm }}>Veľký/malý TP, poistné zmluvy (PZP, havarijná), leasingová zmluva, FA. Foto alebo PDF. AI vyplní polia karty:</div>
            <div style={{ display: 'flex', gap: SPACE.sm, marginBottom: SPACE.md, flexWrap: 'wrap' }}>
              <DocAiButton record={record} onAiFill={onAiFill} endpoint="/api/vehicles/insurance-extract" label="Načítať z poistky (AI)" fields={['pzp_insurer', 'pzp_policy', 'insurance', 'pzp_premium', 'havarijna_insurer', 'havarijna_do', 'havarijna_premium']} />
              <DocAiButton record={record} onAiFill={onAiFill} endpoint="/api/vehicles/leasing-extract" label="Načítať z leasingu (AI)" fields={['leasing', 'leasing_end']} />
            </div>
            <AttachmentsPanel entityType="vehicle_doc" entityId={record.id} showPhase={false} />
          </div>
        ) : tab === 'damage' ? (
          <DamagesTabV vehicleId={record.id} />
        ) : tab === 'protokol' ? (
          <ProtokolTabV record={record} emps={emps} onReload={onReload} />
        ) : tab === 'fotky' ? (
          <div style={{ paddingTop: SPACE.md }}>
            <AttachmentsPanel entityType="vehicle" entityId={record.id} showPhase={false} />
          </div>
        ) : (
          // audit kto/čo/kedy (ústava 12.0 bod 1).
          // POZN: auto-audit zapisuje entity_id len pri PUT/PATCH/DELETE
          // (úpravy). CREATE má entity_id prázdny — kto vytvoril záznam
          // pribudne keď backend dostane logAudit() helper (ROADMAP, 9.D.6).
          <HistoryPanel module={CFG.resource} entityId={record.id} />
        )}
      </div>
    </div>
  )
}

// ── ServiceTabV — vehicle_service (ústava 58.6 servisná kniha) ────────────
// Servisný plán — orientačné intervaly (bežná prax SK, fuel-aware). Presné = manuál výrobcu. (Mirko 2026-06-13)
function vehicleServicePlan(fuel) {
  const f = (fuel || '').toLowerCase()
  const plan = [
    ['Olej + olejový filter', '15 000 km / 1 rok'],
    ['Kabínový filter', '15 000 km'],
    ['Vzduchový filter', '30 000 km'],
  ]
  if (/diesel|nafta/.test(f)) plan.push(['Palivový filter (diesel)', '60 000 km'])
  plan.push(['Brzdová kvapalina', 'výmena každé 2 roky'])
  plan.push(['Rozvody (remeň/reťaz)', '~120 000 km / 5 rokov — podľa výrobcu'])
  plan.push(['Brzdy (platničky/kotúče)', 'kontrola každý servis'])
  plan.push(['Chladiaca kvapalina', 'kontrola, výmena ~5 rokov'])
  plan.push(['STK + EK (osobné)', '1. po 4 rokoch, potom každé 2 roky (zákon)'])
  return plan
}
function ServiceTabV({ record, onReload }) {
  const vehicleId = record.id
  const parseSpec = (s) => { try { const o = JSON.parse(s || '{}'); return Array.isArray(o.items) ? o.items : [] } catch (_) { return [] } }
  const [spec, setSpec] = useState(() => parseSpec(record.service_spec))
  // RESET pri prepnutí auta — inak by ostal servis predošlého vozidla (Mirko 2026-06-13)
  useEffect(() => { setSpec(parseSpec(record.service_spec)) }, [record.id, record.service_spec])
  const [specBusy, setSpecBusy] = useState(false)
  const genSpec = async () => {
    setSpecBusy(true)
    try {
      const r = await fetchAuth(`/api/vehicles/${vehicleId}/service-spec`, { method: 'POST' })
      const d = await r.json().catch(() => ({}))
      if (d.noKey) { toast.error('AI kľúč nie je nakonfigurovaný'); setSpecBusy(false); return }
      setSpec((d.spec && Array.isArray(d.spec.items)) ? d.spec.items : [])
      toast.success('Servisný plán načítaný z AI'); if (onReload) onReload()
    } catch (_) { toast.error('AI servis zlyhal') }
    setSpecBusy(false)
  }
  const [rows, setRows] = useState(null)
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({
    date: todayLocal(),
    km: '', type: 'iné', description: '',
    supplier: '', cost: '', next_date: '', next_km: '',
  })
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  function load() {
    fetchAuth(`/api/vehicle-service/${vehicleId}`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setRows(Array.isArray(d) ? d : []))
      .catch(() => setRows([]))
  }
  useEffect(load, [vehicleId])
  async function add() {
    if (!form.date) { toast.error('Vyplň dátum'); return }
    setBusy(true)
    try {
      const r = await fetchAuth('/api/vehicle-service', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...form, vehicle_id: vehicleId,
          km: Number(form.km) || 0, cost: Number(form.cost) || 0, next_km: Number(form.next_km) || 0 }),
      })
      if (!r.ok) throw new Error('failed')
      toast.success('Servis pridaný')
      setShowForm(false)
      setForm({ date: todayLocal(), km: '', type: 'iné', description: '', supplier: '', cost: '', next_date: '', next_km: '' })
      load()
    } catch (e) { toast.error('Chyba') } finally { setBusy(false) }
  }
  async function del(id) {
    if (!confirm('Zmazať servisný záznam?')) return
    const r = await fetchAuth(`/api/vehicle-service/${id}`, { method: 'DELETE' })
    if (r.ok) { toast.error('Zmazané'); load() } else toast.error('Chyba')
  }
  const faRef = useRef(null)
  const [faBusy, setFaBusy] = useState(false)
  const onFaInvoice = async (e) => {
    const f = e.target.files && e.target.files[0]; e.target.value = ''
    if (!f) return
    setFaBusy(true)
    try {
      const fd = new FormData(); fd.append('file', f)
      const r = await fetchAuth('/api/vehicles/service-invoice-extract', { method: 'POST', body: fd })
      const d = await r.json().catch(() => ({}))
      if (d.noKey) { toast.error('AI kľúč nie je nakonfigurovaný'); setFaBusy(false); return }
      const ex = d.extracted || {}
      setForm(prev => ({
        ...prev,
        date: ex.date || prev.date,
        supplier: ex.supplier || prev.supplier,
        cost: (ex.cost !== null && ex.cost !== undefined && ex.cost !== '') ? ex.cost : prev.cost,
        km: (ex.km !== null && ex.km !== undefined && ex.km !== '') ? ex.km : prev.km,
        description: ex.description || prev.description,
      }))
      setShowForm(true)
      toast.success('FA načítaná — skontroluj a Ulož servis')
    } catch (_) { toast.error('AI z FA zlyhala') }
    setFaBusy(false)
  }
  if (!rows) return <div style={{ padding: SPACE.md, color: COLORS.muted }}>Načítavam…</div>
  const veh = [record.brand, record.model].filter(Boolean).join(' ') || record.name
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div style={{ border: `1px solid ${COLORS.warn}`, borderRadius: RADIUS.md, background: 'rgba(245,158,11,0.07)', padding: SPACE.md }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 8, marginBottom: 6 }}>
          <div style={{ fontSize: TYPO.sizes.sm, fontWeight: 800, color: '#92400e' }}>Predpísaná údržba — {veh}{record.fuel ? ' · ' + record.fuel : ''}</div>
          <Btn variant="ghost" onClick={genSpec} disabled={specBusy}>{specBusy ? 'AI hľadá…' : (spec.length ? 'Aktualizovať (AI)' : 'Načítať (AI)')}</Btn>
        </div>
        {spec.length === 0 ? (
          <div style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted, lineHeight: 1.5 }}>Klikni <b>„Načítať (AI)"</b> — AI nájde konkrétne servisné údaje pre <b>{veh}</b>{record.vin ? ' (VIN ' + record.vin + ')' : ''}: olej + náplne (presná špec.), intervaly, rozvody (reťaz/remeň), filtre, brzdová kvapalina, prevodovka, AdBlue…</div>
        ) : (
          <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
            <tbody>{spec.map((it, i) => (
              <tr key={i} style={{ borderTop: i ? `1px solid rgba(245,158,11,0.25)` : 'none' }}>
                <td style={{ padding: '4px 8px 4px 0', fontWeight: 700, whiteSpace: 'nowrap', verticalAlign: 'top', color: COLORS.text }}>{it.ukon}</td>
                <td style={{ padding: '4px 8px 4px 0', fontFamily: TYPO.mono, whiteSpace: 'nowrap', verticalAlign: 'top', color: COLORS.nav }}>{it.interval}</td>
                <td style={{ padding: '4px 0', color: COLORS.text, verticalAlign: 'top' }}>{it.detail}</td>
              </tr>
            ))}</tbody>
          </table>
        )}
        <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginTop: 6 }}>Zdroj: AI (Claude) podľa modelu/VIN. Vždy over v servisnej knihe výrobcu.</div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end', gap: SPACE.sm }}>
        <input ref={faRef} type="file" accept="image/*,application/pdf" capture="environment" style={{ display: 'none' }} onChange={onFaInvoice} />
        <Btn variant="ghost" onClick={() => faRef.current && faRef.current.click()} disabled={faBusy}>{faBusy ? 'AI číta FA…' : 'Načítať z FA (AI)'}</Btn>
        <BtnAdd onClick={() => setShowForm(s => !s)} size="sm">
          {showForm ? 'Zrušiť' : '+ Servisný záznam'}
        </BtnAdd>
      </div>
      {showForm && (
        <div style={{ padding: SPACE.md, background: COLORS.bgSoft,
          border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
          display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
            <FieldS label="Dátum"><input type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Km stav"><input type="number" value={form.km} onChange={e => setForm({...form, km: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Typ">
              <select value={form.type} onChange={e => setForm({...form, type: e.target.value})} style={inpS}>
                <option value="STK">STK</option>
                <option value="EK">Emisná kontrola</option>
                <option value="poistka">Poistka</option>
                <option value="diaľničná">Diaľničná</option>
                <option value="olej">Výmena oleja</option>
                <option value="pneumatiky">Pneumatiky</option>
                <option value="oprava">Oprava</option>
                <option value="iné">Iné</option>
              </select>
            </FieldS>
          </div>
          <FieldS label="Popis"><input type="text" value={form.description} onChange={e => setForm({...form, description: e.target.value})} placeholder="napr. Výmena ložísk, brzdy…" style={inpS} /></FieldS>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: SPACE.sm }}>
            <FieldS label="Dodávateľ"><input type="text" value={form.supplier} onChange={e => setForm({...form, supplier: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Cena (€)"><input type="number" step="0.01" value={form.cost} onChange={e => setForm({...form, cost: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Ďalší — dátum"><input type="date" value={form.next_date} onChange={e => setForm({...form, next_date: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Ďalší — km"><input type="number" value={form.next_km} onChange={e => setForm({...form, next_km: e.target.value})} style={inpS} /></FieldS>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <BtnAdd onClick={add} disabled={busy} size="sm">{busy ? 'Ukladám…' : 'Uložiť servis'}</BtnAdd>
          </div>
        </div>
      )}
      {rows.length === 0 ? (
        <div style={{ padding: SPACE.md, color: COLORS.muted, fontSize: TYPO.sizes.sm, textAlign: 'center' }}>
          Žiadne servisné záznamy.
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <thead>
            <tr style={{ borderBottom: `2px solid ${COLORS.line}` }}>
              <ThS>Dátum</ThS><ThS>Typ</ThS><ThS>Popis</ThS><ThS>Dodávateľ</ThS>
              <ThS align="right">Km</ThS><ThS align="right">Cena</ThS><ThS>Ďalší</ThS><ThS />
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                <td style={tdM}>{r.date}</td>
                <td style={tdC}>{r.type}</td>
                <td style={tdC}>{r.description}</td>
                <td style={tdC}>{r.supplier || '—'}</td>
                <td style={{ ...tdM, textAlign: 'right' }}>{r.km ? Number(r.km).toLocaleString() : '—'}</td>
                <td style={{ ...tdM, textAlign: 'right', fontWeight: TYPO.weights.semibold }}>{r.cost ? SK.eur(r.cost) : '—'}</td>
                <td style={{ ...tdM, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>
                  {r.next_date || '—'}{r.next_km ? ` · ${Number(r.next_km).toLocaleString()} km` : ''}
                </td>
                <td style={{ ...tdC, textAlign: 'right' }}>
                  <button onClick={() => del(r.id)} style={btnDel}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}

// ── FuelTabV — vehicle_fuel ──────────────────────────────────────────────
function FuelTabV({ vehicleId }) {
  const [rows, setRows] = useState(null)
  const [showForm, setShowForm] = useState(false)
  const [form, setForm] = useState({
    date: todayLocal(),
    km: '', liters: '', price_per_l: '', total_cost: '',
    station: '', full_tank: true,
  })
  const [busy, setBusy] = useState(false)
  const toast = useToast()
  function load() {
    fetchAuth(`/api/vehicle-fuel/${vehicleId}`)
      .then(r => r.ok ? r.json() : [])
      .then(d => setRows(Array.isArray(d) ? d : []))
      .catch(() => setRows([]))
  }
  useEffect(load, [vehicleId])
  async function add() {
    if (!form.date || !form.km || !form.liters) { toast.error('Vyplň dátum, km, litre'); return }
    setBusy(true)
    try {
      const total = Number(form.total_cost) || (Number(form.liters) * Number(form.price_per_l))
      const r = await fetchAuth('/api/vehicle-fuel', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          ...form, vehicle_id: vehicleId,
          km: Number(form.km) || 0,
          liters: Number(form.liters) || 0,
          price_per_l: Number(form.price_per_l) || 0,
          total_cost: total,
          full_tank: form.full_tank ? 1 : 0,
        }),
      })
      if (!r.ok) throw new Error('failed')
      toast.success('Tankovanie pridané')
      setShowForm(false)
      setForm({ date: todayLocal(), km: '', liters: '', price_per_l: '', total_cost: '', station: '', full_tank: true })
      load()
    } catch (e) { toast.error('Chyba') } finally { setBusy(false) }
  }
  async function del(id) {
    if (!confirm('Zmazať tankovanie?')) return
    const r = await fetchAuth(`/api/vehicle-fuel/${id}`, { method: 'DELETE' })
    if (r.ok) { toast.error('Zmazané'); load() } else toast.error('Chyba')
  }
  // Avg consumption — len medzi plnými tankami
  const avg = useMemo(() => {
    if (!rows || rows.length < 2) return null
    const fullTanks = rows.filter(r => r.full_tank).sort((a,b) => (a.date || '').localeCompare(b.date || ''))
    if (fullTanks.length < 2) return null
    const first = fullTanks[0], last = fullTanks[fullTanks.length - 1]
    const km = Number(last.km) - Number(first.km)
    const liters = fullTanks.slice(1).reduce((a,r) => a + (Number(r.liters) || 0), 0)
    if (km <= 0 || liters <= 0) return null
    return (liters / km * 100).toFixed(2)
  }, [rows])
  if (!rows) return <div style={{ padding: SPACE.md, color: COLORS.muted }}>Načítavam…</div>
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.md }}>
        {avg && (
          <div style={{
            padding: '8px 14px',
            background: 'rgba(59,130,246,0.08)',
            border: `1px solid ${COLORS.nav}`, borderRadius: RADIUS.md,
            fontSize: TYPO.sizes.sm, fontWeight: TYPO.weights.semibold, color: COLORS.nav,
          }}>
            Priem. spotreba: <span style={{ fontFamily: TYPO.mono }}>{avg} L / 100 km</span>
          </div>
        )}
        <div style={{ flex: 1 }} />
        <BtnAdd onClick={() => setShowForm(s => !s)} size="sm">
          {showForm ? '✕ Zrušiť' : '+ Tankovanie'}
        </BtnAdd>
      </div>
      {showForm && (
        <div style={{ padding: SPACE.md, background: COLORS.bgSoft,
          border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md,
          display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.sm }}>
            <FieldS label="Dátum"><input type="date" value={form.date} onChange={e => setForm({...form, date: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Km stav"><input type="number" value={form.km} onChange={e => setForm({...form, km: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Stanica"><input type="text" value={form.station} onChange={e => setForm({...form, station: e.target.value})} placeholder="napr. Slovnaft" style={inpS} /></FieldS>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr 1fr', gap: SPACE.sm }}>
            <FieldS label="Litre"><input type="number" step="0.01" value={form.liters} onChange={e => setForm({...form, liters: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Cena/L (€)"><input type="number" step="0.001" value={form.price_per_l} onChange={e => setForm({...form, price_per_l: e.target.value})} style={inpS} /></FieldS>
            <FieldS label="Spolu (€)"><input type="number" step="0.01" value={form.total_cost} onChange={e => setForm({...form, total_cost: e.target.value})} placeholder="auto z L × cena" style={inpS} /></FieldS>
            <FieldS label="Plný tank">
              <label style={{ display: 'flex', alignItems: 'center', gap: 6, paddingTop: 8 }}>
                <input type="checkbox" checked={form.full_tank} onChange={e => setForm({...form, full_tank: e.target.checked})} />
                <span style={{ fontSize: TYPO.sizes.xs }}>áno (pre spotrebu)</span>
              </label>
            </FieldS>
          </div>
          <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
            <BtnAdd onClick={add} disabled={busy} size="sm">{busy ? 'Ukladám…' : 'Uložiť tankovanie'}</BtnAdd>
          </div>
        </div>
      )}
      {rows.length === 0 ? (
        <div style={{ padding: SPACE.md, color: COLORS.muted, fontSize: TYPO.sizes.sm, textAlign: 'center' }}>
          Žiadne tankovania.
        </div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <thead>
            <tr style={{ borderBottom: `2px solid ${COLORS.line}` }}>
              <ThS>Dátum</ThS><ThS>Stanica</ThS>
              <ThS align="right">Km</ThS><ThS align="right">Litre</ThS>
              <ThS align="right">Cena/L</ThS><ThS align="right">Spolu</ThS>
              <ThS align="center">Plný</ThS><ThS />
            </tr>
          </thead>
          <tbody>
            {rows.map(r => (
              <tr key={r.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
                <td style={tdM}>{r.date}</td>
                <td style={tdC}>{r.station || '—'}</td>
                <td style={{ ...tdM, textAlign: 'right' }}>{r.km ? Number(r.km).toLocaleString() : '—'}</td>
                <td style={{ ...tdM, textAlign: 'right' }}>{Number(r.liters || 0).toFixed(2)} L</td>
                <td style={{ ...tdM, textAlign: 'right' }}>{Number(r.price_per_l || 0).toFixed(3)} €</td>
                <td style={{ ...tdM, textAlign: 'right', fontWeight: TYPO.weights.semibold }}>{SK.eur(r.total_cost)}</td>
                <td style={{ ...tdC, textAlign: 'center' }}>{r.full_tank ? '✓' : ''}</td>
                <td style={{ ...tdC, textAlign: 'right' }}>
                  <button onClick={() => del(r.id)} style={btnDel}>✕</button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  )
}
const tdM = { padding: '6px 8px', fontFamily: TYPO.mono, fontSize: TYPO.sizes.sm }
const tdC = { padding: '6px 8px', fontSize: TYPO.sizes.sm }
const inpS = { width: '100%', padding: '6px 8px', border: `1px solid ${COLORS.line}`,
  borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, background: COLORS.bg, color: COLORS.text,
  boxSizing: 'border-box' }
function FieldS({ label, children }) {
  return <label style={{ display: 'block' }}>
    <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginBottom: 2, fontWeight: TYPO.weights.semibold,
      textTransform: 'uppercase', letterSpacing: '0.04em' }}>{label}</div>
    {children}
  </label>
}
function ThS({ children, align = 'left' }) {
  return <th style={{ padding: '6px 8px', textAlign: align, color: COLORS.muted,
    fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
    textTransform: 'uppercase', letterSpacing: '0.06em' }}>{children}</th>
}
const btnDel = { background: 'transparent', border: 'none', cursor: 'pointer',
  color: COLORS.remove, fontSize: TYPO.sizes.sm, padding: '2px 6px' }

// ── Náklady (TCO) — palivo + servis + poistné per vozidlo (návrh #2) ──
function NakladyTabV({ record }) {
  const [fuel, setFuel] = useState([])
  const [svc, setSvc] = useState([])
  useEffect(() => {
    fetchAuth(`/api/vehicle-fuel/${record.id}`).then(r => r.ok ? r.json() : []).then(d => setFuel(Array.isArray(d) ? d : [])).catch(() => {})
    fetchAuth(`/api/vehicle-service/${record.id}`).then(r => r.ok ? r.json() : []).then(d => setSvc(Array.isArray(d) ? d : [])).catch(() => {})
  }, [record.id])
  const sum = (arr, f) => arr.reduce((s, x) => s + (Number(x[f]) || 0), 0)
  const fuelTot = sum(fuel, 'total_cost'), svcTot = sum(svc, 'cost'), liters = sum(fuel, 'liters')
  const insur = (Number(record.pzp_premium) || 0) + (Number(record.havarijna_premium) || 0)
  const total = fuelTot + svcTot + insur
  const card = (label, val, color) => (
    <div style={{ background: COLORS.bgSoft, borderRadius: RADIUS.md, padding: SPACE.md, borderLeft: `3px solid ${color}` }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{label}</div>
      <div style={{ fontSize: TYPO.sizes.lg, fontWeight: 800, fontFamily: TYPO.mono }}>{val}</div>
    </div>
  )
  return (
    <div style={{ paddingTop: SPACE.md, display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Náklady na vozidlo (celá história tankovaní + servisov). Poistné = ročné z karty. Leasing splátky doplň keď bude pole.</div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px,1fr))', gap: SPACE.sm }}>
        {card('Palivo (Σ)', fuelTot.toFixed(0) + ' €', COLORS.total)}
        {card('Servis (Σ)', svcTot.toFixed(0) + ' €', COLORS.warn)}
        {card('Poistné / rok', insur.toFixed(0) + ' €', COLORS.nav)}
        {card('SPOLU', total.toFixed(0) + ' €', COLORS.brand)}
      </div>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(130px,1fr))', gap: SPACE.sm }}>
        {card('Natankované', liters.toFixed(0) + ' L', COLORS.muted)}
        {card('Tankovaní', String(fuel.length), COLORS.muted)}
        {card('Servisov', String(svc.length), COLORS.muted)}
        {card('Stav km', record.km ? String(record.km) : '—', COLORS.muted)}
      </div>
    </div>
  )
}

// ── Poškodenia vozidla (návrh: evidencia poškodení) ──
// ── ProtokolTabV — protokol prevzatia/odovzdania vozidla (Mirko 2026-06-29): km + číselník zamestnancov + fotky z mobilu ──
function ProtokolTabV({ record, emps = [], onReload }) {
  const toast = useToast()
  const vehicleId = record.id
  const [rows, setRows] = useState([])
  const [adding, setAdding] = useState(false)
  const blank = { typ: 'prevzatie', employee_id: '', km: record.km || '', datum: todayLocal(), fuel_level: '', damages: '', note: '' }
  const [form, setForm] = useState(blank)
  const [files, setFiles] = useState([])
  const [busy, setBusy] = useState(false)
  const fileRef = useRef(null)
  const load = () => fetchAuth(`/api/vehicle-protocols/${vehicleId}`).then(r => r.ok ? r.json() : []).then(d => setRows(Array.isArray(d) ? d : [])).catch(() => {})
  useEffect(() => { load() }, [vehicleId])
  const empOpts = (emps || []).map(e => ({ value: e.id, label: e.name || e.id }))
  const save = async () => {
    if (!form.employee_id) { toast.error('Vyber zamestnanca z číselníka'); return }
    if (busy) return; setBusy(true)
    try {
      const fd = new FormData()
      fd.append('vehicle_id', vehicleId); fd.append('typ', form.typ); fd.append('employee_id', form.employee_id)
      fd.append('km', String(Number(form.km) || 0)); fd.append('datum', form.datum); fd.append('note', form.note || '')
      fd.append('fuel_level', form.fuel_level || ''); fd.append('damages', form.damages || '')
      const emp = emps.find(e => e.id === form.employee_id); fd.append('employee_name', emp ? (emp.name || '') : '')
      ;(files || []).forEach(f => fd.append('photos', f))
      const r = await fetchAuth('/api/vehicle-protocols', { method: 'POST', body: fd })
      const j = await r.json().catch(() => ({})); if (!r.ok) throw new Error(j.error || '')
      toast.success('Protokol uložený'); setAdding(false); setForm({ ...blank, km: form.km }); setFiles([]); if (fileRef.current) fileRef.current.value = ''; load(); if (onReload) onReload()
    } catch (e) { toast.error('Nepodarilo sa: ' + (e.message || '')) } finally { setBusy(false) }
  }
  const del = async (id) => { if (!window.confirm('Zmazať protokol?')) return; try { await fetchAuth(`/api/vehicle-protocols/${id}`, { method: 'DELETE' }); load() } catch (_) {} }
  const inp = { width: '100%', padding: '6px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, boxSizing: 'border-box' }
  return (
    <div style={{ paddingTop: SPACE.md, display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Pri <b>prevzatí / odovzdaní</b> zaeviduj <b>km</b>, <b>zamestnanca</b> (pridelí sa mu auto), <b>stav nádrže</b>, <b>poškodenia</b> a <b>fotky</b>. Robí admin / majiteľ / office / predajňa.</div>
      {adding ? (
        <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.md, background: COLORS.bgSoft, display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          <div style={{ display: 'flex', gap: SPACE.sm }}>
            {[['prevzatie', 'Prevzatie'], ['odovzdanie', 'Odovzdanie']].map(([v, l]) => (
              <button key={v} onClick={() => setForm(f => ({ ...f, typ: v }))} style={{ flex: 1, padding: '8px', border: `1px solid ${form.typ === v ? COLORS.brand : COLORS.line}`, background: form.typ === v ? COLORS.brand : '#fff', color: form.typ === v ? '#fff' : COLORS.text, borderRadius: RADIUS.sm, cursor: 'pointer', fontWeight: 700, fontFamily: 'inherit' }}>{l}</button>
            ))}
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 110px 140px 130px', gap: SPACE.sm }}>
            <div><div style={protoLbl}>Zamestnanec (pridelí sa mu)</div><SearchableSelect value={form.employee_id} onChange={v => setForm(f => ({ ...f, employee_id: v }))} options={empOpts} placeholder="vyber zamestnanca…" /></div>
            <div><div style={protoLbl}>Počet km</div><input type="number" value={form.km} onChange={e => setForm(f => ({ ...f, km: e.target.value }))} style={inp} /></div>
            <div><div style={protoLbl}>Stav nádrže (odhad)</div>
              <select value={form.fuel_level} onChange={e => setForm(f => ({ ...f, fuel_level: e.target.value }))} style={inp}>
                <option value="">—</option><option value="Plná">Plná</option><option value="3/4">3/4</option><option value="1/2">1/2</option><option value="1/4">1/4</option><option value="Rezerva">Rezerva</option>
              </select>
            </div>
            <div><div style={protoLbl}>Dátum</div><input type="date" value={form.datum} onChange={e => setForm(f => ({ ...f, datum: e.target.value }))} style={inp} /></div>
          </div>
          <div><div style={protoLbl}>Poškodenia <span style={{ fontWeight: 400, color: COLORS.muted }}>(ak sú, hneď sa zapíšu do tabu Poškodenia)</span></div><input value={form.damages} onChange={e => setForm(f => ({ ...f, damages: e.target.value }))} placeholder="napr. škrabanec ľavé dvere, prasknuté zrkadlo… (prázdne = bez poškodení)" style={inp} /></div>
          <div><div style={protoLbl}>Poznámka</div><input value={form.note} onChange={e => setForm(f => ({ ...f, note: e.target.value }))} placeholder="špina, výbava, iné…" style={inp} /></div>
          <div><div style={protoLbl}>Fotky (z mobilu)</div>
            <input ref={fileRef} type="file" accept="image/*" capture="environment" multiple onChange={e => setFiles(Array.from(e.target.files || []))} style={{ fontSize: TYPO.sizes.sm }} />
            {files.length > 0 && <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted, marginLeft: 8 }}>{files.length} fotiek pripravených</span>}
          </div>
          <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
            <Btn variant="ghost" onClick={() => { setAdding(false); setForm(blank); setFiles([]) }}>Zrušiť</Btn>
            <BtnAdd onClick={save} disabled={busy}>{busy ? 'Ukladám…' : 'Uložiť protokol'}</BtnAdd>
          </div>
        </div>
      ) : <div><BtnAdd onClick={() => setAdding(true)}>+ Nový záznam (prevzatie / odovzdanie)</BtnAdd></div>}

      {rows.length === 0 ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadne záznamy.</div> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          {rows.map(r => {
            let ph = []; try { ph = JSON.parse(r.foto_json || '[]') } catch (_) {}
            return (
              <div key={r.id} style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.sm, background: '#fff' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: SPACE.sm, flexWrap: 'wrap' }}>
                  {(() => { const m = { odovzdanie: ['Odovzdanie', COLORS.warn], pozicanie: ['Požičanie', COLORS.nav] }[r.typ] || ['Prevzatie', COLORS.add]; return <span style={{ fontSize: 11, fontWeight: 800, color: '#fff', background: m[1], borderRadius: RADIUS.full, padding: '2px 9px' }}>{m[0]}</span> })()}
                  <span style={{ fontFamily: TYPO.mono, fontSize: TYPO.sizes.xs, color: COLORS.muted }}>{r.datum}</span>
                  <b style={{ fontSize: TYPO.sizes.sm }}>{r.employee_name || r.employee_id}</b>
                  <span style={{ fontSize: TYPO.sizes.sm, color: COLORS.muted }}>· {Number(r.km) || 0} km</span>
                  {r.fuel_level ? <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>· {r.fuel_level}</span> : null}
                  {r.damages ? <span style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, color: COLORS.remove }}>· {r.damages}</span> : null}
                  {r.note ? <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>· {r.note}</span> : null}
                  <span style={{ flex: 1 }} />
                  <span style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>odovzdal: {r.handed_by || '—'}</span>
                  <span onClick={() => del(r.id)} title="zmazať" style={{ cursor: 'pointer', color: COLORS.remove }}>✕</span>
                </div>
                {ph.length > 0 && (
                  <div style={{ display: 'flex', gap: 6, marginTop: 6, flexWrap: 'wrap' }}>
                    {ph.map((u, i) => <a key={i} href={u} target="_blank" rel="noopener noreferrer"><img src={u} alt="" style={{ width: 64, height: 64, objectFit: 'cover', borderRadius: RADIUS.sm, border: `1px solid ${COLORS.line}` }} /></a>)}
                  </div>
                )}
              </div>
            )
          })}
        </div>
      )}
    </div>
  )
}
const protoLbl = { fontSize: 11, color: '#6b7280', fontWeight: 600, marginBottom: 3 }

function DamagesTabV({ vehicleId }) {
  const [rows, setRows] = useState([])
  const [adding, setAdding] = useState(false)
  const blank = { date: todayLocal(), description: '', status: 'neopravené', cost: '' }
  const [form, setForm] = useState(blank)
  const toast = useToast()
  const load = () => fetchAuth(`/api/vehicle-damages/${vehicleId}`).then(r => r.ok ? r.json() : []).then(d => setRows(Array.isArray(d) ? d : [])).catch(() => {})
  useEffect(() => { load() }, [vehicleId])
  const save = async () => {
    if (!form.description.trim()) { toast.error('Zadaj popis poškodenia'); return }
    try { const r = await fetchAuth('/api/vehicle-damages', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ vehicle_id: vehicleId, ...form, cost: Number(form.cost) || 0 }) }); if (!r.ok) throw new Error(); toast.success('Poškodenie zapísané'); setAdding(false); setForm(blank); load() } catch (_) { toast.error('Chyba') }
  }
  const del = async (id) => { try { await fetchAuth(`/api/vehicle-damages/${id}`, { method: 'DELETE' }); load() } catch (_) {} }
  const toggle = async (d) => { try { await fetchAuth(`/api/vehicle-damages/${d.id}`, { method: 'PUT', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ ...d, status: d.status === 'opravené' ? 'neopravené' : 'opravené' }) }); load() } catch (_) {} }
  const inp = { width: '100%', padding: '6px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, boxSizing: 'border-box' }
  return (
    <div style={{ paddingTop: SPACE.md, display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      {adding ? (
        <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.md, background: COLORS.bgSoft, display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr 120px', gap: SPACE.sm }}>
            <input type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} style={inp} />
            <input value={form.description} onChange={e => setForm(f => ({ ...f, description: e.target.value }))} placeholder="napr. škrabanec ľavé dvere, prasknuté sklo…" style={inp} />
            <input type="number" step="0.01" value={form.cost} onChange={e => setForm(f => ({ ...f, cost: e.target.value }))} placeholder="cena €" style={inp} />
          </div>
          <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end' }}>
            <Btn variant="ghost" onClick={() => { setAdding(false); setForm(blank) }}>Zrušiť</Btn>
            <BtnAdd onClick={save}>Uložiť</BtnAdd>
          </div>
        </div>
      ) : <div><BtnAdd onClick={() => setAdding(true)}>+ Poškodenie</BtnAdd></div>}
      {rows.length === 0 ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadne poškodenia. (Fotky pridaj v tabe Fotky.)</div> : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <thead><tr style={{ borderBottom: `1px solid ${COLORS.line}`, color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase' }}>
            <th style={{ textAlign: 'left', padding: '4px 6px' }}>Dátum</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Popis</th><th style={{ textAlign: 'right', padding: '4px 6px' }}>Cena</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Stav</th><th></th>
          </tr></thead>
          <tbody>{rows.map(r => (
            <tr key={r.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '5px 6px', fontFamily: TYPO.mono, whiteSpace: 'nowrap' }}>{r.date}</td>
              <td style={{ padding: '5px 6px' }}>{r.description}</td>
              <td style={{ padding: '5px 6px', textAlign: 'right', fontFamily: TYPO.mono }}>{Number(r.cost) > 0 ? Number(r.cost).toFixed(2) + ' €' : '—'}</td>
              <td style={{ padding: '5px 6px' }}><span onClick={() => toggle(r)} title="prepnúť stav" style={{ cursor: 'pointer', fontSize: 10, fontWeight: 800, color: '#fff', background: r.status === 'opravené' ? COLORS.add : COLORS.warn, borderRadius: RADIUS.full, padding: '2px 9px' }}>{r.status}</span></td>
              <td style={{ padding: '5px 6px', textAlign: 'right' }}><span onClick={() => del(r.id)} title="zmazať" style={{ cursor: 'pointer', color: COLORS.remove }}>✕</span></td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </div>
  )
}

// ── DVIR — pred-jazdná kontrola (návrh #1) ──
const DVIR_ITEMS = ['Pneumatiky', 'Svetlá', 'Brzdy', 'Kvapaliny (olej/chladiaca)', 'Stierače', 'Trojuholník + lekárnička', 'Čistota']
const FUEL_LEVELS = ['plná', '3/4', '1/2', '1/4', 'rezerva']
function KontrolaTabV({ vehicleId, currentKm }) {
  const { meno } = usePersony()
  const [rows, setRows] = useState(null)
  const [adding, setAdding] = useState(false)
  const blank = () => ({ date: todayLocal(), km: currentKm || '', fuel_level: '1/2', checklist: {}, defects: '', note: '' })
  const [form, setForm] = useState(blank())
  const toast = useToast()
  const load = () => fetchAuth(`/api/vehicle-inspections/${vehicleId}`).then(r => r.ok ? r.json() : []).then(d => setRows(Array.isArray(d) ? d : [])).catch(() => setRows([]))
  useEffect(() => { load() }, [vehicleId])
  const setItem = (it, val) => setForm(f => ({ ...f, checklist: { ...f.checklist, [it]: val } }))
  const allOk = DVIR_ITEMS.every(it => form.checklist[it] !== 'chyba') && !form.defects.trim()
  const save = async () => {
    try {
      const r = await fetchAuth('/api/vehicle-inspections', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ vehicle_id: vehicleId, ...form, km: Number(form.km) || 0, ok: allOk }) })
      if (!r.ok) throw new Error()
      toast.success(allOk ? 'Kontrola OK uložená' : 'Kontrola uložená — chyba zapísaná do Poškodení')
      setAdding(false); setForm(blank()); load()
    } catch (_) { toast.error('Chyba') }
  }
  const del = async (id) => { try { await fetchAuth(`/api/vehicle-inspections/${id}`, { method: 'DELETE' }); load() } catch (_) {} }
  if (rows === null) return <div style={{ paddingTop: SPACE.md, color: COLORS.muted }}>Načítavam…</div>
  const inp = { width: '100%', padding: '6px 10px', border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, boxSizing: 'border-box' }
  const tgl = (on, color) => ({ padding: '3px 12px', fontSize: TYPO.sizes.xs, fontWeight: 700, borderRadius: RADIUS.full, cursor: 'pointer', border: `1px solid ${color}`, color: on ? '#fff' : color, background: on ? color : 'transparent' })
  return (
    <div style={{ paddingTop: SPACE.md, display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
      <div style={{ fontSize: TYPO.sizes.xs, color: COLORS.muted }}>Pred-jazdná kontrola (DVIR). Nájdená chyba → automaticky <b>Poškodenie</b>. Fotky pridaj v tabe Fotky.</div>
      {adding ? (
        <div style={{ border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.md, padding: SPACE.md, background: COLORS.bgSoft, display: 'flex', flexDirection: 'column', gap: SPACE.sm }}>
          <div style={{ display: 'grid', gridTemplateColumns: '160px 1fr 1fr', gap: SPACE.sm }}>
            <FieldS label="Dátum"><input type="date" value={form.date} onChange={e => setForm(f => ({ ...f, date: e.target.value }))} style={inp} /></FieldS>
            <FieldS label="Km stav"><input type="number" value={form.km} onChange={e => setForm(f => ({ ...f, km: e.target.value }))} style={inp} /></FieldS>
            <FieldS label="Palivo"><select value={form.fuel_level} onChange={e => setForm(f => ({ ...f, fuel_level: e.target.value }))} style={inp}>{FUEL_LEVELS.map(l => <option key={l} value={l}>{l}</option>)}</select></FieldS>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
            {DVIR_ITEMS.map(it => {
              const v = form.checklist[it]
              return (
                <div key={it} style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '3px 0' }}>
                  <span style={{ flex: 1, fontSize: TYPO.sizes.sm }}>{it}</span>
                  <span onClick={() => setItem(it, 'ok')} style={tgl(v !== 'chyba', COLORS.add)}>OK</span>
                  <span onClick={() => setItem(it, 'chyba')} style={tgl(v === 'chyba', COLORS.remove)}>Chyba</span>
                </div>
              )
            })}
          </div>
          <FieldS label="Poškodenie / chyba (popis — vytvorí Poškodenie)"><input value={form.defects} onChange={e => setForm(f => ({ ...f, defects: e.target.value }))} placeholder="napr. prasknuté čelné sklo, defekt pneu…" style={inp} /></FieldS>
          <FieldS label="Poznámka"><input value={form.note} onChange={e => setForm(f => ({ ...f, note: e.target.value }))} style={inp} /></FieldS>
          <div style={{ display: 'flex', gap: SPACE.sm, justifyContent: 'flex-end', alignItems: 'center' }}>
            <span style={{ fontSize: TYPO.sizes.xs, fontWeight: 700, color: allOk ? COLORS.add : COLORS.remove }}>{allOk ? 'Stav: OK' : 'Stav: CHYBA'}</span>
            <Btn variant="ghost" onClick={() => { setAdding(false); setForm(blank()) }}>Zrušiť</Btn>
            <BtnAdd onClick={save}>Uložiť kontrolu</BtnAdd>
          </div>
        </div>
      ) : <div><BtnAdd onClick={() => setAdding(true)}>+ Pred-jazdná kontrola</BtnAdd></div>}
      {rows.length === 0 ? <div style={{ color: COLORS.muted, fontSize: TYPO.sizes.sm }}>Žiadne kontroly.</div> : (
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
          <thead><tr style={{ borderBottom: `1px solid ${COLORS.line}`, color: COLORS.muted, fontSize: TYPO.sizes.xs, textTransform: 'uppercase' }}>
            <th style={{ textAlign: 'left', padding: '4px 6px' }}>Dátum</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Km</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Palivo</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Stav</th><th style={{ textAlign: 'left', padding: '4px 6px' }}>Kto</th><th></th>
          </tr></thead>
          <tbody>{rows.map(r => (
            <tr key={r.id} style={{ borderBottom: `1px solid ${COLORS.lineSoft}` }}>
              <td style={{ padding: '5px 6px', fontFamily: TYPO.mono, whiteSpace: 'nowrap' }}>{r.date}</td>
              <td style={{ padding: '5px 6px', fontFamily: TYPO.mono }}>{r.km || '—'}</td>
              <td style={{ padding: '5px 6px' }}>{r.fuel_level || '—'}</td>
              <td style={{ padding: '5px 6px' }}><span style={{ fontSize: 10, fontWeight: 800, color: '#fff', background: r.ok ? COLORS.add : COLORS.remove, borderRadius: RADIUS.full, padding: '2px 9px' }}>{r.ok ? 'OK' : 'CHYBA'}</span>{r.defects ? <span style={{ marginLeft: 6, fontSize: TYPO.sizes.xs, color: COLORS.remove }}>{r.defects}</span> : null}</td>
              <td style={{ padding: '5px 6px', color: COLORS.muted, fontSize: TYPO.sizes.xs }}>{meno(r.created_by) || '—'}</td>
              <td style={{ padding: '5px 6px', textAlign: 'right' }}><span onClick={() => del(r.id)} title="zmazať" style={{ cursor: 'pointer', color: COLORS.remove }}>✕</span></td>
            </tr>
          ))}</tbody>
        </table>
      )}
    </div>
  )
}

function VSekcia({ title }) {
  return <div style={{ fontSize: TYPO.sizes.xs, fontWeight: 800, color: COLORS.nav, textTransform: 'uppercase', letterSpacing: '.04em', marginTop: SPACE.md, marginBottom: 4, borderBottom: `1px solid ${COLORS.line}`, paddingBottom: 3 }}>{title}</div>
}
// KrosF — boxová bunka detailu (rovnaký štýl ako katalóg Požičovne, Mirko 2026-06-13)
function KrosF({ label, value, mono }) {
  return (
    <div style={{ minWidth: 0 }}>
      <div style={{ fontSize: 10, fontWeight: 700, color: COLORS.muted, textTransform: 'uppercase', letterSpacing: '.04em', marginBottom: 2 }}>{label}</div>
      <div style={{ padding: '4px 9px', background: COLORS.bg, border: `1px solid ${COLORS.line}`, borderRadius: RADIUS.sm, fontSize: TYPO.sizes.sm, fontWeight: 600, fontFamily: mono ? TYPO.mono : 'inherit', wordBreak: 'break-word', minHeight: 22, color: COLORS.text }}>{(value !== null && value !== undefined && value !== '') ? value : '—'}</div>
    </div>
  )
}

// ══════════════════════════════════════════════════════════════════
// RECORD MODAL — edit / new cez useRecordEditor (S1)
// Lock + dirty + Form→Confirm + DIFF — všetko zabudované v hooku.
// ══════════════════════════════════════════════════════════════════
function RecordModal({ open, record, aiPatch, user, onClose, onSaved }) {
  const isNew = !record
  const [emps, setEmps] = useState([])
  useEffect(() => {
    if (!open) return
    fetchAuth('/api/employees')
      .then(r => r.ok ? r.json() : [])
      .then(d => setEmps(Array.isArray(d) ? d : (d.rows || [])))
      .catch(() => {})
  }, [open])

  const ed = useRecordEditor({
    resource: CFG.resource,
    id: record?.id || null,
    user,
    initial: {
      name:        record?.name        || '',
      plate:       record?.plate       || '',
      vin:         record?.vin         || '',
      year:        record?.year        || '',
      color:       record?.color       || '',
      fuel:        record?.fuel        || '',
      km:          record?.km          || '',
      stk:         record?.stk         || '',
      insurance:   record?.insurance   || '',
      vignette:    record?.vignette    || '',
      green_card:  record?.green_card  || '',
      leasing:     record?.leasing     || '',
      leasing_end: record?.leasing_end || '',
      assigned_to_employee_id: record?.assigned_to_employee_id || '',
      brand:       record?.brand       || '',
      model:       record?.model       || '',
      vehicle_type: record?.vehicle_type || '',
      first_registration: record?.first_registration || '',
      transmission: record?.transmission || '',
      seats:       record?.seats       || '',
      max_weight:  record?.max_weight  || '',
      engine_cc:   record?.engine_cc   || '',
      power_kw:    record?.power_kw     || '',
      ek:          record?.ek          || '',
      pzp_insurer: record?.pzp_insurer || '',
      pzp_policy:  record?.pzp_policy  || '',
      pzp_premium: record?.pzp_premium || '',
      havarijna_insurer: record?.havarijna_insurer || '',
      havarijna_do: record?.havarijna_do || '',
      havarijna_premium: record?.havarijna_premium || '',
      keys_count:  record?.keys_count  || '',
      keys_location: record?.keys_location || '',
      tyre_spec:   record?.tyre_spec   || '',
      owner:       record?.owner       || '',
      holder:      record?.holder      || '',
      notes:       record?.notes       || '',
    },
    fields: EDIT_FIELDS,
    onSubmit: async (values) => {
      const r = await fetchAuth(
        isNew ? CFG.apiBase : `${CFG.apiBase}/${record.id}`,
        { method: isNew ? 'POST' : 'PUT', body: JSON.stringify(values) }
      )
      if (!r.ok) {
        const d = await r.json().catch(() => ({}))
        // dedup (ústava sek. 13) — backend vracia 409 pri duplicite
        if (r.status === 409) throw new Error(d.message || 'Taký záznam už existuje.')
        throw new Error(d.error || 'Uloženie zlyhalo.')
      }
    },
  })

  // AI z TP/poistky/leasingu — aplikuj načítané hodnoty ako PENDING zmeny (aby DIFF/Uložiť fungovalo)
  const aiAppliedRef = useRef(false)
  useEffect(() => {
    if (!aiPatch || typeof aiPatch !== 'object' || !ed.canEdit || aiAppliedRef.current) return
    const clean = {}; Object.entries(aiPatch).forEach(([k, v]) => { if (v !== null && v !== undefined && v !== '') clean[k] = v })
    if (Object.keys(clean).length) { ed.setValues(clean); aiAppliedRef.current = true }
  // eslint-disable-next-line
  }, [aiPatch, ed.canEdit])

  if (!open) return null

  const doClose = () => ed.requestClose(onClose)

  const validate = (v) => {
    if (!v.name || !v.name.trim()) return 'Názov vozidla je povinný.'
    return null
  }

  const handleConfirm = async () => {
    const ok = await ed.submit()
    if (ok) onSaved()
  }

  const readOnly = !ed.canEdit

  return (
    <>
      <Modal
        open
        onClose={doClose}
        onDirtyClose={doClose}
        isDirty={ed.isDirty}
        title={isNew ? CFG.newLabel : `Upraviť — ${record.name}`}
        subtitle={ed.phase === 'confirm' ? 'Skontroluj zmeny pred uložením' : ''}
        maxWidth={640}
        footer={
          ed.phase === 'form' ? (
            <>
              <BtnGhost onClick={doClose}>Zrušiť</BtnGhost>
              <BtnAdd onClick={() => ed.goConfirm(validate)} disabled={readOnly}>
                Uložiť →
              </BtnAdd>
            </>
          ) : (
            <>
              <BtnGhost onClick={ed.back}>← Späť na úpravu</BtnGhost>
              <BtnAdd onClick={handleConfirm} disabled={ed.submitting}>
                {ed.submitting ? 'Ukladám…' : '✓ Potvrdiť uloženie'}
              </BtnAdd>
            </>
          )
        }
      >
        {/* LOCK banner — záznam upravuje niekto iný (ústava 53.7) */}
        {readOnly && ed.lockedBy && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>
            Záznam práve upravuje <strong>{ed.lockedBy}</strong>. Editácia je zamknutá.
          </div>
        )}

        {ed.error && (
          <div style={{
            background: TINT.remove,
            border: `1px solid ${COLORS.remove}`,
            borderRadius: RADIUS.md,
            padding: SPACE.sm,
            marginBottom: SPACE.md,
            fontSize: TYPO.sizes.sm,
            color: COLORS.remove,
          }}>{ed.error}</div>
        )}

        {ed.phase === 'form' ? (
          // ── FORM fáza ──────────────────────────────────────────────
          <div style={{ display: 'flex', flexDirection: 'column', gap: SPACE.md }}>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
              <Field label="Názov *">
                <input type="text" value={ed.values.name} disabled={readOnly}
                  onChange={e => ed.set('name', e.target.value)} style={inputStyle} /></Field>
              <Field label="ŠPZ">
                <input type="text" value={ed.values.plate} disabled={readOnly}
                  onChange={e => ed.set('plate', e.target.value)} style={inputStyle} /></Field>
              <Field label="VIN">
                <input type="text" value={ed.values.vin} disabled={readOnly}
                  onChange={e => ed.set('vin', e.target.value)} style={inputStyle} /></Field>
              <Field label="Značka">
                <input type="text" value={ed.values.brand} disabled={readOnly}
                  onChange={e => ed.set('brand', e.target.value)} style={inputStyle} /></Field>
              <Field label="Model">
                <input type="text" value={ed.values.model} disabled={readOnly}
                  onChange={e => ed.set('model', e.target.value)} style={inputStyle} /></Field>
              <Field label="Typ vozidla">
                <select value={ed.values.vehicle_type} disabled={readOnly}
                  onChange={e => ed.set('vehicle_type', e.target.value)} style={inputStyle}>
                  <option value="">—</option><option value="osobné">Osobné</option><option value="dodávka">Dodávka</option><option value="nákladné">Nákladné</option><option value="príves">Príves</option><option value="stroj">Stroj</option>
                </select></Field>
              <Field label="1. evidencia">
                <input type="text" value={ed.values.first_registration} disabled={readOnly} placeholder="RRRR-MM-DD"
                  onChange={e => ed.set('first_registration', e.target.value)} style={inputStyle} /></Field>
              <Field label="Výkon (kW)">
                <input type="text" value={ed.values.power_kw} disabled={readOnly}
                  onChange={e => ed.set('power_kw', e.target.value)} style={inputStyle} /></Field>
              <Field label="Objem (cm³)">
                <input type="text" value={ed.values.engine_cc} disabled={readOnly}
                  onChange={e => ed.set('engine_cc', e.target.value)} style={inputStyle} /></Field>
              <Field label="Prevodovka">
                <input type="text" value={ed.values.transmission} disabled={readOnly} placeholder="manuál / automat"
                  onChange={e => ed.set('transmission', e.target.value)} style={inputStyle} /></Field>
              <Field label="Počet miest">
                <input type="text" value={ed.values.seats} disabled={readOnly}
                  onChange={e => ed.set('seats', e.target.value)} style={inputStyle} /></Field>
              <Field label="Najv. hmotnosť (kg)">
                <input type="text" value={ed.values.max_weight} disabled={readOnly}
                  onChange={e => ed.set('max_weight', e.target.value)} style={inputStyle} /></Field>
              <Field label="Rok">
                <input type="text" value={ed.values.year} disabled={readOnly}
                  onChange={e => ed.set('year', e.target.value)} style={inputStyle} /></Field>
              <Field label="Farba">
                <input type="text" value={ed.values.color} disabled={readOnly}
                  onChange={e => ed.set('color', e.target.value)} style={inputStyle} /></Field>
              <Field label="Palivo">
                <input type="text" value={ed.values.fuel} disabled={readOnly}
                  onChange={e => ed.set('fuel', e.target.value)} style={inputStyle} /></Field>
              <Field label="Stav km">
                <input type="text" value={ed.values.km} disabled={readOnly}
                  onChange={e => ed.set('km', e.target.value)} style={inputStyle} /></Field>
              <Field label="STK do">
                <input type="text" value={ed.values.stk} disabled={readOnly} placeholder="RRRR-MM-DD"
                  onChange={e => ed.set('stk', e.target.value)} style={inputStyle} /></Field>
              <Field label="EK do">
                <input type="text" value={ed.values.ek} disabled={readOnly} placeholder="RRRR-MM-DD"
                  onChange={e => ed.set('ek', e.target.value)} style={inputStyle} /></Field>
              <Field label="Poistka do">
                <input type="text" value={ed.values.insurance} disabled={readOnly} placeholder="RRRR-MM-DD"
                  onChange={e => ed.set('insurance', e.target.value)} style={inputStyle} /></Field>
              <Field label="Diaľničná do">
                <input type="text" value={ed.values.vignette} disabled={readOnly} placeholder="RRRR-MM-DD"
                  onChange={e => ed.set('vignette', e.target.value)} style={inputStyle} /></Field>
              <Field label="Zelená karta do">
                <input type="text" value={ed.values.green_card} disabled={readOnly} placeholder="RRRR-MM-DD"
                  onChange={e => ed.set('green_card', e.target.value)} style={inputStyle} /></Field>
              <Field label="Leasing do">
                <input type="text" value={ed.values.leasing_end} disabled={readOnly} placeholder="RRRR-MM-DD"
                  onChange={e => ed.set('leasing_end', e.target.value)} style={inputStyle} /></Field>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
              <Field label="PZP — poisťovňa">
                <input type="text" value={ed.values.pzp_insurer} disabled={readOnly}
                  onChange={e => ed.set('pzp_insurer', e.target.value)} style={inputStyle} /></Field>
              <Field label="PZP — číslo zmluvy">
                <input type="text" value={ed.values.pzp_policy} disabled={readOnly}
                  onChange={e => ed.set('pzp_policy', e.target.value)} style={inputStyle} /></Field>
              <Field label="PZP — poistné (€/rok)">
                <input type="text" value={ed.values.pzp_premium} disabled={readOnly}
                  onChange={e => ed.set('pzp_premium', e.target.value)} style={inputStyle} /></Field>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: SPACE.md }}>
              <Field label="Havarijná — poisťovňa">
                <input type="text" value={ed.values.havarijna_insurer} disabled={readOnly}
                  onChange={e => ed.set('havarijna_insurer', e.target.value)} style={inputStyle} /></Field>
              <Field label="Havarijná — do">
                <input type="text" value={ed.values.havarijna_do} disabled={readOnly} placeholder="RRRR-MM-DD"
                  onChange={e => ed.set('havarijna_do', e.target.value)} style={inputStyle} /></Field>
              <Field label="Havarijná — poistné (€/rok)">
                <input type="text" value={ed.values.havarijna_premium} disabled={readOnly}
                  onChange={e => ed.set('havarijna_premium', e.target.value)} style={inputStyle} /></Field>
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 2fr', gap: SPACE.md }}>
              <Field label="Počet kľúčov">
                <input type="text" value={ed.values.keys_count} disabled={readOnly}
                  onChange={e => ed.set('keys_count', e.target.value)} style={inputStyle} /></Field>
              <Field label="Kde sú kľúče">
                <input type="text" value={ed.values.keys_location} disabled={readOnly} placeholder="napr. trezor recepcia · u vodiča · sklad"
                  onChange={e => ed.set('keys_location', e.target.value)} style={inputStyle} /></Field>
            </div>
            <Field label="Pneumatiky — doporučené rozmery (z TP)">
              <input type="text" value={ed.values.tyre_spec} disabled={readOnly} placeholder="napr. 245/45 R18; 235/55 R17"
                onChange={e => ed.set('tyre_spec', e.target.value)} style={inputStyle} /></Field>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: SPACE.md }}>
              <Field label="Majiteľ (vlastník)">
                <input type="text" value={ed.values.owner} disabled={readOnly} placeholder="meno / firma / leasingovka"
                  onChange={e => ed.set('owner', e.target.value)} style={inputStyle} /></Field>
              <Field label="Držiteľ">
                <input type="text" value={ed.values.holder} disabled={readOnly} placeholder="meno / firma"
                  onChange={e => ed.set('holder', e.target.value)} style={inputStyle} /></Field>
            </div>
            <Field label="Leasing (spoločnosť)">
              <input type="text" value={ed.values.leasing} disabled={readOnly}
                onChange={e => ed.set('leasing', e.target.value)} style={inputStyle} /></Field>
            <Field label="Pridelené zamestnancovi (vodič / vlastník)">
              <SearchableSelect
                value={ed.values.assigned_to_employee_id}
                onChange={v => ed.set('assigned_to_employee_id', v)}
                options={emps.filter(e => e.active).map(e => ({ value: e.id, label: e.name + (e.party ? ` · ${e.party}` : '') }))}
                placeholder="— vyberte zamestnanca alebo nechajte prázdne —"
                emptyLabel="— nepridelené —" />
            </Field>
            <Field label="Poznámka">
              <textarea value={ed.values.notes} disabled={readOnly}
                onChange={e => ed.set('notes', e.target.value)} rows={3}
                style={{ ...inputStyle, resize: 'vertical' }} /></Field>
          </div>
        ) : (
          // ── CONFIRM fáza — DIFF prehľad (ústava 53.8) ───────────────
          <div>
            {isNew ? (
              <p style={{ fontSize: TYPO.sizes.base, color: COLORS.text }}>
                Vytvorí sa nové vozidlo <strong>{ed.values.name}</strong>.
              </p>
            ) : ed.diff.length === 0 ? (
              <p style={{ color: COLORS.muted }}>Žiadne zmeny.</p>
            ) : (
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: TYPO.sizes.sm }}>
                <thead>
                  <tr style={{ background: TINT.nav }}>
                    <th style={thStyle}>Pole</th>
                    <th style={thStyle}>Pôvodné</th>
                    <th style={thStyle}>Nové</th>
                  </tr>
                </thead>
                <tbody>
                  {ed.diff.map(d => (
                    <tr key={d.name}>
                      <td style={tdStyle}>{d.label}</td>
                      <td style={{ ...tdStyle, color: COLORS.muted, textDecoration: 'line-through' }}>
                        {d.from}
                      </td>
                      <td style={{ ...tdStyle, color: COLORS.add, fontWeight: TYPO.weights.semibold }}>
                        {d.to}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            )}
          </div>
        )}
      </Modal>

      {/* DIRTY dialóg — Uložiť / Pokračovať / Zahodiť (ústava 53.1) */}
      <Modal.DirtyConfirm {...ed.dirtyProps} />
    </>
  )
}

function Field({ label, children }) {
  return (
    <label style={{ display: 'block' }}>
      <div style={{
        fontSize: TYPO.sizes.xs, fontWeight: TYPO.weights.semibold,
        color: COLORS.muted, marginBottom: 4, textTransform: 'uppercase',
        letterSpacing: '0.04em',
      }}>{label}</div>
      {children}
    </label>
  )
}

const inputStyle = {
  width: '100%',
  padding: '6px 10px',
  fontSize: TYPO.sizes.base,
  fontFamily: 'inherit',
  border: `1px solid ${COLORS.line}`,
  borderRadius: RADIUS.md,
  outline: 'none',
  boxSizing: 'border-box',
}
const thStyle = {
  textAlign: 'left', padding: '6px 10px',
  fontSize: TYPO.sizes.xs, color: COLORS.nav,
  textTransform: 'uppercase', letterSpacing: '0.04em',
  borderBottom: `1px solid ${COLORS.line}`,
}
const tdStyle = {
  padding: '6px 10px',
  borderBottom: `1px solid ${COLORS.lineSoft}`,
}

// ╔══════════════════════════════════════════════════════════════════╗
// ║  DoD CHECKLIST — skopíruj do HANDOFF, odškrtni pred dokončením    ║
// ║  (ústava 9.D.1 bod 3). Modul NIE JE hotový kým nie sú všetky ✅.  ║
// ╠══════════════════════════════════════════════════════════════════╣
// ║  [ ] CFG vyplnené (resource, apiBase, labels)                    ║
// ║  [ ] EDIT_FIELDS = všetky editovateľné polia (kvôli DIFF)        ║
// ║  [ ] LOCK funguje — test 2 okná naraz (53.7)                     ║
// ║  [ ] DIRTY dialóg pri zatvorení s neuloženými zmenami (53.1)     ║
// ║  [ ] Form → Confirm + DIFF pred uložením (12.0/3, 53.8)         ║
// ║  [ ] HistoryPanel ukazuje audit záznamu (12.0/1)                 ║
// ║  [ ] hľadanie v zozname funguje (56)                             ║
// ║  [ ] žiadny plain <select> — len SearchableSelect (56.11)        ║
// ║  [ ] žiadne inline farby pozadia — len TINT/tint() (21.15)       ║
// ║  [ ] dedup — backend vracia 409 pri duplicite (13)               ║
// ║  [ ] mod+N a / skratky + cheatsheet (54)                         ║
// ║  [ ] starý modul porovnaný — všetky polia/funkcie prenesené      ║
// ║  [ ] ÚSTAVA-REVIEW — druhý prechod kódu bod po bode (9.D.3)      ║
// ╚══════════════════════════════════════════════════════════════════╝
